import React, { useContext, useEffect, useState } from 'react';
import HeaderMainFooter from '../templates/HeaderMainFooter';
import { Button, Typography, Badge, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../components/SearchInput';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AdvancedFilter from '../components/AdvancedFilter';
import PeriodSelector from '../components/PeriodSelector';
import SearchTypeSelector from '../components/SearchTypeSelector';
import logo from "./../assets/quanto_custa_logo_home.png";
import Footer from '../components/Footer';
import endpoints from '../constants/endpoints';
import useApiRequest from '../services/apiRequest';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

function Home() {
    const { userPermissions, setUserPermissions } = useContext(GlobalStateContext);
    const { get, getApimToken } = useApiRequest();
    const [token, setToken] = useState('');



    const { apimToken, setApimToken } = React.useContext(GlobalStateContext);
    const { apimExpTime, setApimExpTime } = React.useContext(GlobalStateContext);

    const { currentUser, setCurrentUser } = React.useContext(GlobalStateContext);
    const [showModal, setShowModal] = useState<boolean>(false)
    const { typedDescription, setTypedDescription } = useContext(GlobalStateContext);
    const { description, setDescription } = useContext(GlobalStateContext);
    const { typedFilters, setTypedFilters, cleanFacetsFilters } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);
    const { searchTerm, setSearchTerm } = useContext(GlobalStateContext);

    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const { filters, setFilters } = useContext(GlobalStateContext);
    const { countFilters } = useContext(GlobalStateContext)
    const navigate = useNavigate();

    const onSearch = (ev: React.FormEvent<HTMLFormElement>) => {
        cleanFacetsFilters();
        setTypedDescription(searchTerm);
        setDescription(searchTerm);
        setFilters(typedFilters);
        setSearchType(typedSearchType);
        ev.preventDefault();
        navigate('/result')
    }

    const getToken = async () => {
        const resp = await getApimToken();
        const access_token = resp.access_token;
        const expTime = resp.expires_in;
        setApimExpTime(expTime);
        setApimToken(access_token);
        setToken(access_token);
    };

    useEffect(() => {
        if (currentUser?.profile.username && !apimToken) {
            getToken();
            const intervalId = setInterval(() => {
                getToken();
            }, 3540000);
            return () => clearInterval(intervalId);
        }
    }, [currentUser]);


    useEffect(() => {
        if (token && currentUser?.profile.username && currentUser?.profile.username != userPermissions.usuario) {
            getPermissions(token);
        }
    }, [currentUser, token]);

    const getPermissions = async (token: string) => {
        try {
            const resp = await get(endpoints.USER_PERMISSIONS, { user: currentUser?.profile.username }, token);
            setUserPermissions(resp);
        } catch (error) {
            console.error("Erro ao buscar permissões:", error);
        }
    };

    return (
        <>
            <HeaderMainFooter />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: '5%' }} >
                <AdvancedFilter open={showModal} onClose={() => setShowModal(false)} />
                <div className="w-full max-w-2xl text-center">
                    <div className="my-1 flex gap-1 items-center justify-center">
                        <img src={logo} alt="Banco de Preços" style={{ maxWidth: '50%', maxHeight: '50%', margin: '1em' }} />
                    </div>
                    <form onSubmit={onSearch}>
                        <div className="flex gap-2 items-center">
                            <div className="">
                                <SearchTypeSelector />
                            </div>
                            <div className="flex-1">
                                <SearchInput />
                            </div>
                        </div>

                        <div className="my-4 flex gap-4 items-center">
                            <PeriodSelector />
                        </div>

                        <div className="mt-8">
                            <Button type="submit" disabled={!userPermissions.print_list_items} variant='contained'>Buscar</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Badge badgeContent={countFilters()} color="primary">
                                <Button onClick={() => setShowModal(true)} size='medium'><FilterAltIcon /> Filtro</Button>
                            </Badge>
                        </div>


                    </form>
                </div>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
                <Button
                    variant="text"
                    startIcon={<NewReleasesIcon color="primary" />}
                    sx={{ textDecoration: 'underline' }}
                    onClick={() => navigate('/resultOverprice')}
                >
                    Sobrepreço pré-calculado
                </Button>
            </Box>


            <Box sx={{ position: 'fixed', bottom: 0, width: '100%' }}>
                <Footer />
            </Box>

        </>
    );
}

export default Home;


